import {Component, Input, OnDestroy} from '@angular/core';
import {Store} from '@ngxs/store';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {WebchargeModel} from '../../../services/webcharge/webcharge.model';
import {GetWebchargeDetail} from '../../../../state/actions/appState.webcharges.actions';
import {OpenModalPaymentDetail} from '../../../../state/actions/appState.modals.actions';

@Component({
  selector: 'app-paycard-detail',
  templateUrl: './webcharge-detail-modal.component.html',
  styleUrls: ['./webcharge-detail-modal.component.scss']
})
export class WebchargeDetailModalComponent implements OnDestroy {
  @Input() webcharge: WebchargeModel;

  constructor(
    private store: Store,
    private activeModal: NgbActiveModal
  ) {
  }

  ngOnDestroy(): void {
    this.store.dispatch(new GetWebchargeDetail(null));
  }

  onCloseModal() {
    this.activeModal.dismiss();
  }

  onShowPayment() {
    this.store.dispatch(new OpenModalPaymentDetail(this.webcharge.payment));
  }
}
